const AUTH_ROUTES = "/auth";
const HOME_ROUTES = "/home";
const ACCOUNTS_ROUTES = "/accounts"
const USERS_ROUTES = "/all-users"
const ROUTE_NAMES = (route: any) => {
    if (route === HOME_ROUTES) {
        return "Home";
    }
};

export { AUTH_ROUTES, HOME_ROUTES, ACCOUNTS_ROUTES, USERS_ROUTES, ROUTE_NAMES };
